window.isFormChanged = false
window.isSubmitting = false

export default function() {
    const form = document.querySelector('form')
    if (!form) return
    form.addEventListener('submit', () => {
        window.isSubmitting = true
        window.isFormChanged = false
    });
    form.addEventListener('input', () => {
        window.isFormChanged = true
    });

    window.onbeforeunload = function() {
        if (window.isFormChanged && !window.isSubmitting) {
            return ""
        }
    }
}
